module.exports = __webpack_public_path__ + "static/media/modal-cadastrar-pet-mobile.56b180ec.png";